import Vue from 'vue'
import Vuex from 'vuex'

import pedido from '@/store/pedido/index.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    pageTitle: 'Comex',
  },

  mutations: {
    setPageTitle(state, title) {
      state.pageTitle = title
    },
  },

  getters: {
    isBusy(state) {
      return state.isBusy
    },
  },

  modules: {
    pedido,
  },
})

export default store
